/**
 * Etapes du formulaire de création d'un mandat
 * Décrites côté serveur dans SMAAttribute (FormSteps)
 */
enum SMAFormStepEnum
{
    Distributor = 1,
    Customer = 2,
    Meters = 3,
    Appendixes = 4
}

export default SMAFormStepEnum;